import {ProductCategoryCarousel} from './productCategoryCarousel'

export {ProductCategoryCarousel}
